import React, { useEffect, useState } from 'react'
import { View } from 'styles/reactnative'
import { useExchangeList } from '../../../hooks/trade/exchangeList'
import { Button, Input, Popover, Select, Space } from 'antd'
import { CloseOutlined, SearchOutlined } from '@ant-design/icons'
import TableAPI from '../../../components/TableAPI'
import { PositionOpenTableColumn } from './PositionOpenTableColumn'
import { useUserList } from '../../../hooks/user/userlist'
import ClassificationSelect from '../../../components/AdminUserModal/ClassificationSelect'

const PositionOpen = ({ title, type }: any) => {
	const params = new URLSearchParams(window.location.search)
	const idquery = params.get('userid')

	const [user_id, setUser_id] = useState<any>(idquery || '')
	const [status, setStatus] = useState<any>('*')
	const [ep_id, setEp_id] = useState<any>('*')
	const [level, setLevel] = useState<any>('1')
	const { data: EPS } = useExchangeList()
	const today = new Date().toISOString().slice(0, 10)
	const activeEPS = EPS?.filter((item: any) => item.openstatus !== 4 && item.startdate <= today && item.enddate > today)

	const [refresh, setRefresh] = useState(false)
	useEffect(() => {
		setEp_id('')
	}, [refresh])

	useEffect(() => {
		setTimeout(() => {
			setRefresh(!refresh)
		}, 1000)
	}, [])

	const { usertype1 } = useUserList()

	return (
		<View style={{ width: '100%' }}>
			<View
				style={{
					flexDirection: 'row',
					backgroundColor: 'white',
					width: '100%',
					padding: 10,
					marginTop: 10,
					borderTopLeftRadius: 10,
					borderTopRightRadius: 10,
				}}>
				<View style={{ width: 200 }}>
					<ClassificationSelect
						defaultValue={level}
						setSelectLevel={setLevel}
						disabled={false}
					/>
				</View>

				<Select
					value={ep_id}
					onChange={e => {
						setEp_id(e)
					}}
					filterOption={true}
					options={[
						{ value: '*', label: '전체종목' },
						...activeEPS?.map((item: any) => {
							return {
								value: item.id,
								label: (item.groupname || item.name) + ' (' + item?.pairs + ')',
							}
						}),
					]}
					style={{ marginRight: 10, minWidth: 200 }}
				/>
				<Select
					value={status}
					onChange={e => {
						setStatus(e)
					}}
					filterOption={true}
					options={[
						{ value: '*', label: '매수매도 전체' },
						{ value: 'L', label: '매수' },
						{ value: 'S', label: '매도' },
					]}
					style={{ marginRight: 10 }}
				/>
				<Space.Compact direction="horizontal">
					<Popover
						placement="bottom"
						trigger={'click'}
						content={
							<Space style={{ alignItems: 'center' }}>
								<Select
									style={{ width: '100%', minWidth: 200 }}
									defaultValue={''}
									onChange={e => {
										setUser_id(e)
									}}
									options={[
										{ value: '', label: '전체' },
										...(usertype1 || []),
									]}
								/>
							</Space>
						}>
						<Input
							placeholder="회원코드"
							value={user_id}
							onChange={e => {
								setUser_id(e.target.value)
							}}
						/>
					</Popover>
					<Button
						onClick={() => {
							setUser_id('')
						}}
						style={{ paddingTop: 0 }}
						size="small">
						{user_id ? <CloseOutlined /> : <SearchOutlined />}
					</Button>
				</Space.Compact>
			</View>

			{/* <CanvasPositionOpen /> */}

			<TableAPI
				title={title}
				columns={PositionOpenTableColumn}
				usermodal={true}
				height={'default'}
				width={1350}
				groupsearch={true}
				loadingshow={false}
				autorefresh={5000}
				apikey={
					'/admin/history/positions?ep_id=' +
					ep_id +
					'&user_id=' +
					(user_id || '*') +
					'&status=' +
					status +
					'&level=' +
					level
				}
			/>
		</View>
	)
}

export default React.memo(PositionOpen)
